const flags = [
  {
    "web-scraper-order": "1666026666-1339",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳‍🟧‍⬛‍🟧 Refugee Nation Flag",
    "flags-href": "https://emojipedia.org/refugee-nation-flag/",
    emoji: "🏳‍🟧‍⬛‍🟧",
    emojiName: "🏳‍🟧‍⬛‍🟧 Refugee Nation Flag",
    description:
      "The flag for Refugee Nation; a proposal to create a new nation to resettle refugees. This flag uses a shade of orange commonly used for life vests and life buoys at sea. A thin, horizontal black stripe is shown in the lower-third.",
  },
  {
    "web-scraper-order": "1666026669-1341",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁵󠁳󠁴󠁸󠁿 Flag for Texas (US-TX)",
    "flags-href": "https://emojipedia.org/flag-for-texas-ustx/",
    emoji: "🏴󠁵󠁳󠁴󠁸󠁿",
    emojiName: "🏴󠁵󠁳󠁴󠁸󠁿 Flag for Texas (US-TX)",
    description:
      "The Flag for Texas (US-TX) emoji is a tag sequence combining 🏴 Black Flag, 󠁵 Tag Latin Small Letter U, 󠁳 Tag Latin Small Letter S, 󠁴 Tag Latin Small Letter T, 󠁸 Tag Latin Small Letter X and 󠁿 Cancel Tag.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026672-1343",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Flag: Wales",
    "flags-href": "https://emojipedia.org/flag-wales/",
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    emojiName: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Flag: Wales",
    description:
      "The flag for Wales, a country in the United Kingdom. May show as the letters gbwls.",
  },
  {
    "web-scraper-order": "1666026674-1344",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁳󠁣󠁴󠁿 Flag: Scotland",
    "flags-href": "https://emojipedia.org/flag-scotland/",
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    emojiName: "🏴󠁧󠁢󠁳󠁣󠁴󠁿 Flag: Scotland",
    description:
      "The flag for Scotland, a country in the United Kingdom. May show as the letters gbsct.",
  },
  {
    "web-scraper-order": "1666026676-1346",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁥󠁮󠁧󠁿 Flag: England",
    "flags-href": "https://emojipedia.org/flag-england/",
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    emojiName: "🏴󠁧󠁢󠁥󠁮󠁧󠁿 Flag: England",
    description:
      "The flag for England, a country in the United Kingdom. May show as the letters gbeng.",
  },
  {
    "web-scraper-order": "1666026679-1348",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇼 Flag: Zimbabwe",
    "flags-href": "https://emojipedia.org/flag-zimbabwe/",
    emoji: "🇿🇼",
    emojiName: "🇿🇼 Flag: Zimbabwe",
    description:
      "The flag for Zimbabwe, which may show as the letters ZW on some platforms.",
  },
  {
    "web-scraper-order": "1666026682-1350",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇲 Flag: Zambia",
    "flags-href": "https://emojipedia.org/flag-zambia/",
    emoji: "🇿🇲",
    emojiName: "🇿🇲 Flag: Zambia",
    description:
      "The flag for Zambia, which may show as the letters ZM on some platforms.",
  },
  {
    "web-scraper-order": "1666026684-1352",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇦 Flag: South Africa",
    "flags-href": "https://emojipedia.org/flag-south-africa/",
    emoji: "🇿🇦",
    emojiName: "🇿🇦 Flag: South Africa",
    description:
      "The flag for South Africa, which may show as the letters ZA on some platforms.",
  },
  {
    "web-scraper-order": "1666026687-1353",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇾🇹 Flag: Mayotte",
    "flags-href": "https://emojipedia.org/flag-mayotte/",
    emoji: "🇾🇹",
    emojiName: "🇾🇹 Flag: Mayotte",
    description:
      "The flag for Mayotte, which may show as the letters YT on some platforms.",
  },
  {
    "web-scraper-order": "1666026690-1355",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇾🇪 Flag: Yemen",
    "flags-href": "https://emojipedia.org/flag-yemen/",
    emoji: "🇾🇪",
    emojiName: "🇾🇪 Flag: Yemen",
    description:
      "The flag for Yemen, which may show as the letters YE on some platforms.",
  },
  {
    "web-scraper-order": "1666026693-1357",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇽🇰 Flag: Kosovo",
    "flags-href": "https://emojipedia.org/flag-kosovo/",
    emoji: "🇽🇰",
    emojiName: "🇽🇰 Flag: Kosovo",
    description:
      "The flag for Kosovo, which may show as the letters XK on some platforms.",
  },
  {
    "web-scraper-order": "1666026695-1358",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇼🇸 Flag: Samoa",
    "flags-href": "https://emojipedia.org/flag-samoa/",
    emoji: "🇼🇸",
    emojiName: "🇼🇸 Flag: Samoa",
    description:
      "The flag for Samoa, which may show as the letters WS on some platforms.",
  },
  {
    "web-scraper-order": "1666026698-1360",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇼🇫 Flag: Wallis & Futuna",
    "flags-href": "https://emojipedia.org/flag-wallis-futuna/",
    emoji: "🇼🇫",
    emojiName: "🇼🇫 Flag: Wallis & Futuna",
    description:
      "The Flag: Wallis & Futuna emoji is a flag sequence combining 🇼 Regional Indicator Symbol Letter W and 🇫 Regional Indicator Symbol Letter F.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026701-1362",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇺 Flag: Vanuatu",
    "flags-href": "https://emojipedia.org/flag-vanuatu/",
    emoji: "🇻🇺",
    emojiName: "🇻🇺 Flag: Vanuatu",
    description:
      "The flag for Vanuatu, which may show as the letters VU on some platforms.",
  },
  {
    "web-scraper-order": "1666026705-1364",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇳 Flag: Vietnam",
    "flags-href": "https://emojipedia.org/flag-vietnam/",
    emoji: "🇻🇳",
    emojiName: "🇻🇳 Flag: Vietnam",
    description:
      "The flag for Vietnam, which may show as the letters VN on some platforms.",
  },
  {
    "web-scraper-order": "1666026709-1366",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇮 Flag: U.S. Virgin Islands",
    "flags-href": "https://emojipedia.org/flag-us-virgin-islands/",
    emoji: "🇻🇮",
    emojiName: "🇻🇮 Flag: U.S. Virgin Islands",
    description:
      "The flag for US Virgin Islands, which may show as the letters VI on some platforms.",
  },
  {
    "web-scraper-order": "1666026712-1368",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇬 Flag: British Virgin Islands",
    "flags-href": "https://emojipedia.org/flag-british-virgin-islands/",
    emoji: "🇻🇬",
    emojiName: "🇻🇬 Flag: British Virgin Islands",
    description:
      "The flag for British Virgin Islands, which may show as the letters VG on some platforms.",
  },
  {
    "web-scraper-order": "1666026715-1369",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇪 Flag: Venezuela",
    "flags-href": "https://emojipedia.org/flag-venezuela/",
    emoji: "🇻🇪",
    emojiName: "🇻🇪 Flag: Venezuela",
    description:
      "The flag for Venezuela, which may show as the letters VE on some platforms.",
  },
  {
    "web-scraper-order": "1666026717-1371",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇨 Flag: St. Vincent & Grenadines",
    "flags-href": "https://emojipedia.org/flag-st-vincent-grenadines/",
    emoji: "🇻🇨",
    emojiName: "🇻🇨 Flag: St. Vincent & Grenadines",
    description:
      "The Flag: St. Vincent & Grenadines emoji is a flag sequence combining 🇻 Regional Indicator Symbol Letter V and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026720-1373",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇦 Flag: Vatican City",
    "flags-href": "https://emojipedia.org/flag-vatican-city/",
    emoji: "🇻🇦",
    emojiName: "🇻🇦 Flag: Vatican City",
    description:
      "The flag for Vatican City, which may show as the letters VA on some platforms.",
  },
  {
    "web-scraper-order": "1666026722-1374",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇿 Flag: Uzbekistan",
    "flags-href": "https://emojipedia.org/flag-uzbekistan/",
    emoji: "🇺🇿",
    emojiName: "🇺🇿 Flag: Uzbekistan",
    description:
      "The flag for Uzbekistan, which may show as the letters UZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026741-1378",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇾 Flag: Uruguay",
    "flags-href": "https://emojipedia.org/flag-uruguay/",
    emoji: "🇺🇾",
    emojiName: "🇺🇾 Flag: Uruguay",
    description:
      "The flag for Uruguay, which may show as the letters UY on some platforms.",
  },
  {
    "web-scraper-order": "1666026744-1380",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇸 Flag: United States",
    "flags-href": "https://emojipedia.org/flag-united-states/",
    emoji: "🇺🇸",
    emojiName: "🇺🇸 Flag: United States",
    description:
      "The flag for the United States of America (USA), which may show as the letters US on some platforms.",
  },
  {
    "web-scraper-order": "1666026746-1382",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇳 Flag: United Nations",
    "flags-href": "https://emojipedia.org/flag-united-nations/",
    emoji: "🇺🇳",
    emojiName: "🇺🇳 Flag: United Nations",
    description:
      "The flag for United Nations. May show as the letters UN. This two letter regional indicator pair is an exceptional reservation as part of ISO 3166.",
  },
  {
    "web-scraper-order": "1666026749-1384",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇲 Flag: U.S. Outlying Islands",
    "flags-href": "https://emojipedia.org/flag-us-outlying-islands/",
    emoji: "🇺🇲",
    emojiName: "🇺🇲 Flag: U.S. Outlying Islands",
    description:
      "The flag for U.S. Outlying Islands, which may show as the letters UM on some platforms. This is the same flag as the United States.",
  },
  {
    "web-scraper-order": "1666026752-1386",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇬 Flag: Uganda",
    "flags-href": "https://emojipedia.org/flag-uganda/",
    emoji: "🇺🇬",
    emojiName: "🇺🇬 Flag: Uganda",
    description:
      "The flag for Uganda, which may show as the letters UG on some platforms.",
  },
  {
    "web-scraper-order": "1666026754-1388",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇦 Flag: Ukraine",
    "flags-href": "https://emojipedia.org/flag-ukraine/",
    emoji: "🇺🇦",
    emojiName: "🇺🇦 Flag: Ukraine",
    description:
      "The flag for Ukraine, which may show as the letters UA on some platforms.",
  },
  {
    "web-scraper-order": "1666026757-1390",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇿 Flag: Tanzania",
    "flags-href": "https://emojipedia.org/flag-tanzania/",
    emoji: "🇹🇿",
    emojiName: "🇹🇿 Flag: Tanzania",
    description:
      "The flag for Tanzania, which may show as the letters TZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026759-1392",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇼 Flag: Taiwan",
    "flags-href": "https://emojipedia.org/flag-taiwan/",
    emoji: "🇹🇼",
    emojiName: "🇹🇼 Flag: Taiwan",
    description:
      "The flag for Taiwan (officially Republic of China), which may show as the letters TW on some platforms.",
  },
  {
    "web-scraper-order": "1666026762-1394",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇻 Flag: Tuvalu",
    "flags-href": "https://emojipedia.org/flag-tuvalu/",
    emoji: "🇹🇻",
    emojiName: "🇹🇻 Flag: Tuvalu",
    description:
      "The flag for Tuvalu, which may show as the letters TV on some platforms.",
  },
  {
    "web-scraper-order": "1666026764-1396",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇹 Flag: Trinidad & Tobago",
    "flags-href": "https://emojipedia.org/flag-trinidad-tobago/",
    emoji: "🇹🇹",
    emojiName: "🇹🇹 Flag: Trinidad & Tobago",
    description:
      "The Flag: Trinidad & Tobago emoji is a flag sequence combining 🇹 Regional Indicator Symbol Letter T.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026767-1398",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇷 Flag: Turkey",
    "flags-href": "https://emojipedia.org/flag-turkey/",
    emoji: "🇹🇷",
    emojiName: "🇹🇷 Flag: Turkey",
    description:
      "The flag for Turkey, which may show as the letters TR on some platforms.",
  },
  {
    "web-scraper-order": "1666026769-1399",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇴 Flag: Tonga",
    "flags-href": "https://emojipedia.org/flag-tonga/",
    emoji: "🇹🇴",
    emojiName: "🇹🇴 Flag: Tonga",
    description:
      "The flag for Tonga, which may show as the letters TO on some platforms.",
  },
  {
    "web-scraper-order": "1666026771-1401",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇳 Flag: Tunisia",
    "flags-href": "https://emojipedia.org/flag-tunisia/",
    emoji: "🇹🇳",
    emojiName: "🇹🇳 Flag: Tunisia",
    description:
      "The flag for Tunisia, which may show as the letters TN on some platforms.",
  },
  {
    "web-scraper-order": "1666026774-1403",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇲 Flag: Turkmenistan",
    "flags-href": "https://emojipedia.org/flag-turkmenistan/",
    emoji: "🇹🇲",
    emojiName: "🇹🇲 Flag: Turkmenistan",
    description:
      "The flag for Turkmenistan, which may show as the letters TM on some platforms.",
  },
  {
    "web-scraper-order": "1666026777-1405",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇱 Flag: Timor-Leste",
    "flags-href": "https://emojipedia.org/flag-timor-leste/",
    emoji: "🇹🇱",
    emojiName: "🇹🇱 Flag: Timor-Leste",
    description:
      "The flag for East Timor, which may show as the letters TL on some platforms.",
  },
  {
    "web-scraper-order": "1666026780-1407",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇰 Flag: Tokelau",
    "flags-href": "https://emojipedia.org/flag-tokelau/",
    emoji: "🇹🇰",
    emojiName: "🇹🇰 Flag: Tokelau",
    description:
      "The flag for Tokelau, which may show as the letters TK on some platforms.",
  },
  {
    "web-scraper-order": "1666026783-1409",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇯 Flag: Tajikistan",
    "flags-href": "https://emojipedia.org/flag-tajikistan/",
    emoji: "🇹🇯",
    emojiName: "🇹🇯 Flag: Tajikistan",
    description:
      "The flag for Tajikistan, which may show as the letters TJ on some platforms.",
  },
  {
    "web-scraper-order": "1666026786-1411",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇭 Flag: Thailand",
    "flags-href": "https://emojipedia.org/flag-thailand/",
    emoji: "🇹🇭",
    emojiName: "🇹🇭 Flag: Thailand",
    description:
      "The flag for Thailand, which may show as the letters TH on some platforms.",
  },
  {
    "web-scraper-order": "1666026788-1413",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇬 Flag: Togo",
    "flags-href": "https://emojipedia.org/flag-togo/",
    emoji: "🇹🇬",
    emojiName: "🇹🇬 Flag: Togo",
    description:
      "The flag for Togo, which may show as the letters TG on some platforms.",
  },
  {
    "web-scraper-order": "1666026791-1415",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇫 Flag: French Southern Territories",
    "flags-href": "https://emojipedia.org/flag-french-southern-territories/",
    emoji: "🇹🇫",
    emojiName: "🇹🇫 Flag: French Southern Territories",
    description:
      "The flag for French Southern Territories, which may show as the letters TF on some platforms.",
  },
  {
    "web-scraper-order": "1666026793-1417",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇩 Flag: Chad",
    "flags-href": "https://emojipedia.org/flag-chad/",
    emoji: "🇹🇩",
    emojiName: "🇹🇩 Flag: Chad",
    description:
      "The flag for Chad, which may show as the letters TD on some platforms.",
  },
  {
    "web-scraper-order": "1666026796-1419",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇨 Flag: Turks & Caicos Islands",
    "flags-href": "https://emojipedia.org/flag-turks-caicos-islands/",
    emoji: "🇹🇨",
    emojiName: "🇹🇨 Flag: Turks & Caicos Islands",
    description:
      "The Flag: Turks & Caicos Islands emoji is a flag sequence combining 🇹 Regional Indicator Symbol Letter T and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026799-1421",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇦 Flag: Tristan Da Cunha",
    "flags-href": "https://emojipedia.org/flag-tristan-da-cunha/",
    emoji: "🇹🇦",
    emojiName: "🇹🇦 Flag: Tristan Da Cunha",
    description:
      "The flag for Tristan da Cunha, which may show as the letters TA on some platforms. Apple devices show the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666026802-1423",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇿 Flag: Eswatini",
    "flags-href": "https://emojipedia.org/flag-eswatini/",
    emoji: "🇸🇿",
    emojiName: "🇸🇿 Flag: Eswatini",
    description:
      "The flag for Swaziland, which may show as the letters SZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026804-1425",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇾 Flag: Syria",
    "flags-href": "https://emojipedia.org/flag-syria/",
    emoji: "🇸🇾",
    emojiName: "🇸🇾 Flag: Syria",
    description:
      "The flag for Syria, which may show as the letters SY on some platforms.",
  },
  {
    "web-scraper-order": "1666026806-1427",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇽 Flag: Sint Maarten",
    "flags-href": "https://emojipedia.org/flag-sint-maarten/",
    emoji: "🇸🇽",
    emojiName: "🇸🇽 Flag: Sint Maarten",
    description:
      "The flag for Sint Maarten, which may show as the letters SX on some platforms. This is the Dutch half of the of the Caribbean island of Saint Martin. Not to be confused with St. Martin, the French half of the same island.",
  },
  {
    "web-scraper-order": "1666026809-1429",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇻 Flag: El Salvador",
    "flags-href": "https://emojipedia.org/flag-el-salvador/",
    emoji: "🇸🇻",
    emojiName: "🇸🇻 Flag: El Salvador",
    description:
      "The flag for El Salvador, which may show as the letters SV on some platforms.",
  },
  {
    "web-scraper-order": "1666026812-1431",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇹 Flag: São Tomé & Príncipe",
    "flags-href": "https://emojipedia.org/flag-sao-tome-principe/",
    emoji: "🇸🇹",
    emojiName: "🇸🇹 Flag: São Tomé & Príncipe",
    description:
      "The Flag: São Tomé & Príncipe emoji is a flag sequence combining 🇸 Regional Indicator Symbol Letter S and 🇹 Regional Indicator Symbol Letter T.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026815-1434",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇸 Flag: South Sudan",
    "flags-href": "https://emojipedia.org/flag-south-sudan/",
    emoji: "🇸🇸",
    emojiName: "🇸🇸 Flag: South Sudan",
    description:
      "The flag for South Sudan, which may show as the letters SS on some platforms.",
  },
  {
    "web-scraper-order": "1666026818-1436",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇷 Flag: Suriname",
    "flags-href": "https://emojipedia.org/flag-suriname/",
    emoji: "🇸🇷",
    emojiName: "🇸🇷 Flag: Suriname",
    description:
      "The flag for Suriname, which may show as the letters SR on some platforms.",
  },
  {
    "web-scraper-order": "1666026821-1438",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇴 Flag: Somalia",
    "flags-href": "https://emojipedia.org/flag-somalia/",
    emoji: "🇸🇴",
    emojiName: "🇸🇴 Flag: Somalia",
    description:
      "The flag for Somalia, which may show as the letters SO on some platforms.",
  },
  {
    "web-scraper-order": "1666026823-1440",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇳 Flag: Senegal",
    "flags-href": "https://emojipedia.org/flag-senegal/",
    emoji: "🇸🇳",
    emojiName: "🇸🇳 Flag: Senegal",
    description:
      "The flag for Senegal, which may show as the letters SN on some platforms.",
  },
  {
    "web-scraper-order": "1666026826-1442",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇲 Flag: San Marino",
    "flags-href": "https://emojipedia.org/flag-san-marino/",
    emoji: "🇸🇲",
    emojiName: "🇸🇲 Flag: San Marino",
    description:
      "The flag for San Marino, which may show as the letters SM on some platforms.",
  },
  {
    "web-scraper-order": "1666026829-1444",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇱 Flag: Sierra Leone",
    "flags-href": "https://emojipedia.org/flag-sierra-leone/",
    emoji: "🇸🇱",
    emojiName: "🇸🇱 Flag: Sierra Leone",
    description:
      "The flag for Sierra Leone, which may show as the letters SL on some platforms.",
  },
  {
    "web-scraper-order": "1666026831-1446",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇰 Flag: Slovakia",
    "flags-href": "https://emojipedia.org/flag-slovakia/",
    emoji: "🇸🇰",
    emojiName: "🇸🇰 Flag: Slovakia",
    description:
      "The flag for Slovakia, which may show as the letters SK on some platforms.",
  },
  {
    "web-scraper-order": "1666026833-1448",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇯 Flag: Svalbard & Jan Mayen",
    "flags-href": "https://emojipedia.org/flag-svalbard-jan-mayen/",
    emoji: "🇸🇯",
    emojiName: "🇸🇯 Flag: Svalbard & Jan Mayen",
    description:
      "The flag for Svalbard & Jan Mayen, which may show as the letters SJ on some platforms. This is the same flag as Norway.",
  },
  {
    "web-scraper-order": "1666026836-1450",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇮 Flag: Slovenia",
    "flags-href": "https://emojipedia.org/flag-slovenia/",
    emoji: "🇸🇮",
    emojiName: "🇸🇮 Flag: Slovenia",
    description:
      "The flag for Slovenia, which may show as the letters SI on some platforms.",
  },
  {
    "web-scraper-order": "1666026839-1452",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇭 Flag: St. Helena",
    "flags-href": "https://emojipedia.org/flag-st-helena/",
    emoji: "🇸🇭",
    emojiName: "🇸🇭 Flag: St. Helena",
    description:
      "The flag for St. Helena, which may show as the letters SH on some platforms. Apple devices display the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666026841-1454",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇬 Flag: Singapore",
    "flags-href": "https://emojipedia.org/flag-singapore/",
    emoji: "🇸🇬",
    emojiName: "🇸🇬 Flag: Singapore",
    description:
      "The flag for Singapore, which may show as the letters SG on some platforms.",
  },
  {
    "web-scraper-order": "1666026843-1456",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇪 Flag: Sweden",
    "flags-href": "https://emojipedia.org/flag-sweden/",
    emoji: "🇸🇪",
    emojiName: "🇸🇪 Flag: Sweden",
    description:
      "The flag for Sweden, which may show as the letters SE on some platforms.",
  },
  {
    "web-scraper-order": "1666026846-1458",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇩 Flag: Sudan",
    "flags-href": "https://emojipedia.org/flag-sudan/",
    emoji: "🇸🇩",
    emojiName: "🇸🇩 Flag: Sudan",
    description:
      "The flag for Sudan, which may show as the letters SD on some platforms.",
  },
  {
    "web-scraper-order": "1666026849-1460",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇨 Flag: Seychelles",
    "flags-href": "https://emojipedia.org/flag-seychelles/",
    emoji: "🇸🇨",
    emojiName: "🇸🇨 Flag: Seychelles",
    description:
      "The flag for Seychelles, which may show as the letters SC on some platforms.",
  },
  {
    "web-scraper-order": "1666026852-1462",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇧 Flag: Solomon Islands",
    "flags-href": "https://emojipedia.org/flag-solomon-islands/",
    emoji: "🇸🇧",
    emojiName: "🇸🇧 Flag: Solomon Islands",
    description:
      "The flag for Solomon Islands, which may show as the letters SB on some platforms.",
  },
  {
    "web-scraper-order": "1666026854-1464",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇦 Flag: Saudi Arabia",
    "flags-href": "https://emojipedia.org/flag-saudi-arabia/",
    emoji: "🇸🇦",
    emojiName: "🇸🇦 Flag: Saudi Arabia",
    description:
      "The flag for Saudi Arabia, which may show as the letters SA on some platforms.",
  },
  {
    "web-scraper-order": "1666026856-1466",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇼 Flag: Rwanda",
    "flags-href": "https://emojipedia.org/flag-rwanda/",
    emoji: "🇷🇼",
    emojiName: "🇷🇼 Flag: Rwanda",
    description:
      "The flag for Rwanda, which may show as the letters RW on some platforms.",
  },
  {
    "web-scraper-order": "1666026859-1468",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇺 Flag: Russia",
    "flags-href": "https://emojipedia.org/flag-russia/",
    emoji: "🇷🇺",
    emojiName: "🇷🇺 Flag: Russia",
    description:
      "The flag for Russia, which may show as the letters RU on some platforms.",
  },
  {
    "web-scraper-order": "1666026861-1470",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇸 Flag: Serbia",
    "flags-href": "https://emojipedia.org/flag-serbia/",
    emoji: "🇷🇸",
    emojiName: "🇷🇸 Flag: Serbia",
    description:
      "The flag for Serbia, which may show as the letters RS on some platforms.",
  },
  {
    "web-scraper-order": "1666026864-1472",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇴 Flag: Romania",
    "flags-href": "https://emojipedia.org/flag-romania/",
    emoji: "🇷🇴",
    emojiName: "🇷🇴 Flag: Romania",
    description:
      "The flag for Romania, which may show as the letters RO on some platforms.",
  },
  {
    "web-scraper-order": "1666026867-1474",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇪 Flag: Réunion",
    "flags-href": "https://emojipedia.org/flag-reunion/",
    emoji: "🇷🇪",
    emojiName: "🇷🇪 Flag: Réunion",
    description:
      "The flag for Réunion, which may show as the letters RE on some platforms.",
  },
  {
    "web-scraper-order": "1666026869-1476",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇶🇦 Flag: Qatar",
    "flags-href": "https://emojipedia.org/flag-qatar/",
    emoji: "🇶🇦",
    emojiName: "🇶🇦 Flag: Qatar",
    description:
      "The flag for Qatar, which may show as the letters QA on some platforms.",
  },
  {
    "web-scraper-order": "1666026872-1478",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇾 Flag: Paraguay",
    "flags-href": "https://emojipedia.org/flag-paraguay/",
    emoji: "🇵🇾",
    emojiName: "🇵🇾 Flag: Paraguay",
    description:
      "The flag for Paraguay, which may show as the letters PY on some platforms.",
  },
  {
    "web-scraper-order": "1666026874-1480",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇼 Flag: Palau",
    "flags-href": "https://emojipedia.org/flag-palau/",
    emoji: "🇵🇼",
    emojiName: "🇵🇼 Flag: Palau",
    description:
      "The flag for Palau, which may show as the letters PW on some platforms.",
  },
  {
    "web-scraper-order": "1666026877-1482",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇹 Flag: Portugal",
    "flags-href": "https://emojipedia.org/flag-portugal/",
    emoji: "🇵🇹",
    emojiName: "🇵🇹 Flag: Portugal",
    description:
      "The flag for Portugal, which may show as the letters PT on some platforms.",
  },
  {
    "web-scraper-order": "1666026879-1484",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇸 Flag: Palestinian Territories",
    "flags-href": "https://emojipedia.org/flag-palestinian-territories/",
    emoji: "🇵🇸",
    emojiName: "🇵🇸 Flag: Palestinian Territories",
    description:
      "The Flag: Palestinian Territories emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇸 Regional Indicator Symbol Letter S.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026882-1486",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇷 Flag: Puerto Rico",
    "flags-href": "https://emojipedia.org/flag-puerto-rico/",
    emoji: "🇵🇷",
    emojiName: "🇵🇷 Flag: Puerto Rico",
    description:
      "The flag for Puerto Rico, which may show as the letters PR on some platforms.",
  },
  {
    "web-scraper-order": "1666026886-1488",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇳 Flag: Pitcairn Islands",
    "flags-href": "https://emojipedia.org/flag-pitcairn-islands/",
    emoji: "🇵🇳",
    emojiName: "🇵🇳 Flag: Pitcairn Islands",
    description:
      "The Flag: Pitcairn Islands emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇳 Regional Indicator Symbol Letter N.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026889-1490",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇲 Flag: St. Pierre & Miquelon",
    "flags-href": "https://emojipedia.org/flag-st-pierre-miquelon/",
    emoji: "🇵🇲",
    emojiName: "🇵🇲 Flag: St. Pierre & Miquelon",
    description:
      "The Flag: St. Pierre & Miquelon emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇲 Regional Indicator Symbol Letter M.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026892-1492",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇱 Flag: Poland",
    "flags-href": "https://emojipedia.org/flag-poland/",
    emoji: "🇵🇱",
    emojiName: "🇵🇱 Flag: Poland",
    description:
      "The flag for Poland, which may show as the letters PL on some platforms.",
  },
  {
    "web-scraper-order": "1666026895-1494",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇰 Flag: Pakistan",
    "flags-href": "https://emojipedia.org/flag-pakistan/",
    emoji: "🇵🇰",
    emojiName: "🇵🇰 Flag: Pakistan",
    description:
      "The flag for Pakistan, which may show as the letters PK on some platforms.",
  },
  {
    "web-scraper-order": "1666026898-1495",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇭 Flag: Philippines",
    "flags-href": "https://emojipedia.org/flag-philippines/",
    emoji: "🇵🇭",
    emojiName: "🇵🇭 Flag: Philippines",
    description:
      "The flag for Philippines, which may show as the letters PH on some platforms.",
  },
  {
    "web-scraper-order": "1666026900-1497",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇬 Flag: Papua New Guinea",
    "flags-href": "https://emojipedia.org/flag-papua-new-guinea/",
    emoji: "🇵🇬",
    emojiName: "🇵🇬 Flag: Papua New Guinea",
    description:
      "The flag for Papua New Guinea, which may show as the letters PG on some platforms.",
  },
  {
    "web-scraper-order": "1666026904-1499",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇫 Flag: French Polynesia",
    "flags-href": "https://emojipedia.org/flag-french-polynesia/",
    emoji: "🇵🇫",
    emojiName: "🇵🇫 Flag: French Polynesia",
    description:
      "The flag for French Polynesia, which may show as the letters PF on some platforms.",
  },
  {
    "web-scraper-order": "1666026907-1501",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇪 Flag: Peru",
    "flags-href": "https://emojipedia.org/flag-peru/",
    emoji: "🇵🇪",
    emojiName: "🇵🇪 Flag: Peru",
    description:
      "The flag for Peru, which may show as the letters PE on some platforms.",
  },
  {
    "web-scraper-order": "1666026910-1503",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇦 Flag: Panama",
    "flags-href": "https://emojipedia.org/flag-panama/",
    emoji: "🇵🇦",
    emojiName: "🇵🇦 Flag: Panama",
    description:
      "The flag for Panama, which may show as the letters PA on some platforms.",
  },
  {
    "web-scraper-order": "1666026913-1505",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇴🇲 Flag: Oman",
    "flags-href": "https://emojipedia.org/flag-oman/",
    emoji: "🇴🇲",
    emojiName: "🇴🇲 Flag: Oman",
    description:
      "The flag for Oman, which may show as the letters OM on some platforms.",
  },
  {
    "web-scraper-order": "1666026916-1507",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇿 Flag: New Zealand",
    "flags-href": "https://emojipedia.org/flag-new-zealand/",
    emoji: "🇳🇿",
    emojiName: "🇳🇿 Flag: New Zealand",
    description:
      "The flag for New Zealand, which may show as the letters NZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026919-1509",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇺 Flag: Niue",
    "flags-href": "https://emojipedia.org/flag-niue/",
    emoji: "🇳🇺",
    emojiName: "🇳🇺 Flag: Niue",
    description:
      "The flag for Niue, which may show as the letters NU on some platforms.",
  },
  {
    "web-scraper-order": "1666026922-1511",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇷 Flag: Nauru",
    "flags-href": "https://emojipedia.org/flag-nauru/",
    emoji: "🇳🇷",
    emojiName: "🇳🇷 Flag: Nauru",
    description:
      "The flag for Nauru, which may show as the letters NR on some platforms.",
  },
  {
    "web-scraper-order": "1666026924-1512",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇵 Flag: Nepal",
    "flags-href": "https://emojipedia.org/flag-nepal/",
    emoji: "🇳🇵",
    emojiName: "🇳🇵 Flag: Nepal",
    description:
      "The flag for Nepal, which may show as the letters NP on some platforms.",
  },
  {
    "web-scraper-order": "1666026928-1514",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇴 Flag: Norway",
    "flags-href": "https://emojipedia.org/flag-norway/",
    emoji: "🇳🇴",
    emojiName: "🇳🇴 Flag: Norway",
    description:
      "The flag for Norway, which may show as the letters NO on some platforms.",
  },
  {
    "web-scraper-order": "1666026930-1516",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇱 Flag: Netherlands",
    "flags-href": "https://emojipedia.org/flag-netherlands/",
    emoji: "🇳🇱",
    emojiName: "🇳🇱 Flag: Netherlands",
    description:
      "The flag for Netherlands, which may show as the letters NL on some platforms.",
  },
  {
    "web-scraper-order": "1666026933-1517",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇮 Flag: Nicaragua",
    "flags-href": "https://emojipedia.org/flag-nicaragua/",
    emoji: "🇳🇮",
    emojiName: "🇳🇮 Flag: Nicaragua",
    description:
      "The flag for Nicaragua, which may show as the letters NI on some platforms.",
  },
  {
    "web-scraper-order": "1666026936-1519",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇬 Flag: Nigeria",
    "flags-href": "https://emojipedia.org/flag-nigeria/",
    emoji: "🇳🇬",
    emojiName: "🇳🇬 Flag: Nigeria",
    description:
      "The flag for Nigeria, which may show as the letters NG on some platforms.",
  },
  {
    "web-scraper-order": "1666026938-1522",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇫 Flag: Norfolk Island",
    "flags-href": "https://emojipedia.org/flag-norfolk-island/",
    emoji: "🇳🇫",
    emojiName: "🇳🇫 Flag: Norfolk Island",
    description:
      "The flag for Norfolk Island, which may show as the letters NF on some platforms.",
  },
  {
    "web-scraper-order": "1666026941-1523",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇪 Flag: Niger",
    "flags-href": "https://emojipedia.org/flag-niger/",
    emoji: "🇳🇪",
    emojiName: "🇳🇪 Flag: Niger",
    description:
      "The flag for Niger, which may show as the letters NE on some platforms.",
  },
  {
    "web-scraper-order": "1666026943-1525",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇨 Flag: New Caledonia",
    "flags-href": "https://emojipedia.org/flag-new-caledonia/",
    emoji: "🇳🇨",
    emojiName: "🇳🇨 Flag: New Caledonia",
    description:
      "The flag for New Caledonia, which may show as the letters NC on some platforms.",
  },
  {
    "web-scraper-order": "1666026946-1526",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇦 Flag: Namibia",
    "flags-href": "https://emojipedia.org/flag-namibia/",
    emoji: "🇳🇦",
    emojiName: "🇳🇦 Flag: Namibia",
    description:
      "The flag for Namibia, which may show as the letters NA on some platforms.",
  },
  {
    "web-scraper-order": "1666026949-1528",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇿 Flag: Mozambique",
    "flags-href": "https://emojipedia.org/flag-mozambique/",
    emoji: "🇲🇿",
    emojiName: "🇲🇿 Flag: Mozambique",
    description:
      "The flag for Mozambique, which may show as the letters MZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026952-1530",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇾 Flag: Malaysia",
    "flags-href": "https://emojipedia.org/flag-malaysia/",
    emoji: "🇲🇾",
    emojiName: "🇲🇾 Flag: Malaysia",
    description:
      "The flag for Malaysia, which may show as the letters MY on some platforms.",
  },
  {
    "web-scraper-order": "1666026954-1532",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇽 Flag: Mexico",
    "flags-href": "https://emojipedia.org/flag-mexico/",
    emoji: "🇲🇽",
    emojiName: "🇲🇽 Flag: Mexico",
    description:
      "The flag for Mexico, which may show as the letters MX on some platforms.",
  },
  {
    "web-scraper-order": "1666026957-1534",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇼 Flag: Malawi",
    "flags-href": "https://emojipedia.org/flag-malawi/",
    emoji: "🇲🇼",
    emojiName: "🇲🇼 Flag: Malawi",
    description:
      "The flag for Malawi, which may show as the letters MW on some platforms.",
  },
  {
    "web-scraper-order": "1666026960-1536",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇻 Flag: Maldives",
    "flags-href": "https://emojipedia.org/flag-maldives/",
    emoji: "🇲🇻",
    emojiName: "🇲🇻 Flag: Maldives",
    description:
      "The flag for Maldives, which may show as the letters MV on some platforms.",
  },
  {
    "web-scraper-order": "1666026963-1537",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇺 Flag: Mauritius",
    "flags-href": "https://emojipedia.org/flag-mauritius/",
    emoji: "🇲🇺",
    emojiName: "🇲🇺 Flag: Mauritius",
    description:
      "The flag for Mauritius, which may show as the letters MU on some platforms.",
  },
  {
    "web-scraper-order": "1666026965-1539",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇹 Flag: Malta",
    "flags-href": "https://emojipedia.org/flag-malta/",
    emoji: "🇲🇹",
    emojiName: "🇲🇹 Flag: Malta",
    description:
      "The flag for Malta, which may show as the letters MT on some platforms.",
  },
  {
    "web-scraper-order": "1666026969-1541",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇸 Flag: Montserrat",
    "flags-href": "https://emojipedia.org/flag-montserrat/",
    emoji: "🇲🇸",
    emojiName: "🇲🇸 Flag: Montserrat",
    description:
      "The flag for Montserrat, which may show as the letters MS on some platforms.",
  },
  {
    "web-scraper-order": "1666026971-1543",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇷 Flag: Mauritania",
    "flags-href": "https://emojipedia.org/flag-mauritania/",
    emoji: "🇲🇷",
    emojiName: "🇲🇷 Flag: Mauritania",
    description:
      "The flag for Mauritania, which may show as the letters MR on some platforms. This design changed in August 2017, adding a red band at the top and bottom.",
  },
  {
    "web-scraper-order": "1666026990-1545",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇶 Flag: Martinique",
    "flags-href": "https://emojipedia.org/flag-martinique/",
    emoji: "🇲🇶",
    emojiName: "🇲🇶 Flag: Martinique",
    description:
      "The flag for Martinique, which may show as the letters MQ on some platforms.",
  },
  {
    "web-scraper-order": "1666026993-1548",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇵 Flag: Northern Mariana Islands",
    "flags-href": "https://emojipedia.org/flag-northern-mariana-islands/",
    emoji: "🇲🇵",
    emojiName: "🇲🇵 Flag: Northern Mariana Islands",
    description:
      "The flag for Northern Mariana Islands, which may show as the letters MP on some platforms.",
  },
  {
    "web-scraper-order": "1666026996-1551",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇴 Flag: Macao Sar China",
    "flags-href": "https://emojipedia.org/flag-macao-sar-china/",
    emoji: "🇲🇴",
    emojiName: "🇲🇴 Flag: Macao Sar China",
    description:
      "The flag for Macau, which may show as the letters MO on some platforms.",
  },
  {
    "web-scraper-order": "1666026999-1555",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇳 Flag: Mongolia",
    "flags-href": "https://emojipedia.org/flag-mongolia/",
    emoji: "🇲🇳",
    emojiName: "🇲🇳 Flag: Mongolia",
    description:
      "The flag for Mongolia, which may show as the letters MN on some platforms.",
  },
  {
    "web-scraper-order": "1666027002-1557",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇲 Flag: Myanmar (Burma)",
    "flags-href": "https://emojipedia.org/flag-myanmar-burma/",
    emoji: "🇲🇲",
    emojiName: "🇲🇲 Flag: Myanmar (Burma)",
    description:
      "The flag for Myanmar, which may show as the letters MM on some platforms.",
  },
  {
    "web-scraper-order": "1666027005-1560",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇱 Flag: Mali",
    "flags-href": "https://emojipedia.org/flag-mali/",
    emoji: "🇲🇱",
    emojiName: "🇲🇱 Flag: Mali",
    description:
      "The flag for Mali, which may show as the letters ML on some platforms.",
  },
  {
    "web-scraper-order": "1666027008-1564",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇰 Flag: North Macedonia",
    "flags-href": "https://emojipedia.org/flag-north-macedonia/",
    emoji: "🇲🇰",
    emojiName: "🇲🇰 Flag: North Macedonia",
    description:
      "The flag for North Macedonia (until 2019: Macedonia), which may show as the letters MK on some platforms.",
  },
  {
    "web-scraper-order": "1666027012-1567",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇭 Flag: Marshall Islands",
    "flags-href": "https://emojipedia.org/flag-marshall-islands/",
    emoji: "🇲🇭",
    emojiName: "🇲🇭 Flag: Marshall Islands",
    description:
      "The flag for Marshall Islands, which may show as the letters MH on some platforms.",
  },
  {
    "web-scraper-order": "1666027015-1571",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇬 Flag: Madagascar",
    "flags-href": "https://emojipedia.org/flag-madagascar/",
    emoji: "🇲🇬",
    emojiName: "🇲🇬 Flag: Madagascar",
    description:
      "The flag for Madagascar, which may show as the letters MG on some platforms",
  },
  {
    "web-scraper-order": "1666027018-1574",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇫 Flag: St. Martin",
    "flags-href": "https://emojipedia.org/flag-st-martin/",
    emoji: "🇲🇫",
    emojiName: "🇲🇫 Flag: St. Martin",
    description:
      "The flag for St. Martin, which may show as the letters MF on some platforms. This is the French half of the of the Caribbean island of Saint Martin. Not to be confused with Sint Maarten, the Dutch half of the same island.",
  },
  {
    "web-scraper-order": "1666027020-1577",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇪 Flag: Montenegro",
    "flags-href": "https://emojipedia.org/flag-montenegro/",
    emoji: "🇲🇪",
    emojiName: "🇲🇪 Flag: Montenegro",
    description:
      "The flag for Montenegro, which may show as the letters ME on some platforms",
  },
  {
    "web-scraper-order": "1666027023-1580",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇩 Flag: Moldova",
    "flags-href": "https://emojipedia.org/flag-moldova/",
    emoji: "🇲🇩",
    emojiName: "🇲🇩 Flag: Moldova",
    description:
      "The flag for Moldova, which may show as the letters MD on some platforms.",
  },
  {
    "web-scraper-order": "1666027025-1583",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇨 Flag: Monaco",
    "flags-href": "https://emojipedia.org/flag-monaco/",
    emoji: "🇲🇨",
    emojiName: "🇲🇨 Flag: Monaco",
    description:
      "The flag for Monaco, which may show as the letters MC on some platforms.",
  },
  {
    "web-scraper-order": "1666027027-1586",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇦 Flag: Morocco",
    "flags-href": "https://emojipedia.org/flag-morocco/",
    emoji: "🇲🇦",
    emojiName: "🇲🇦 Flag: Morocco",
    description:
      "The flag for Morocco, which may show as the letters MA on some platforms.",
  },
  {
    "web-scraper-order": "1666027030-1589",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇾 Flag: Libya",
    "flags-href": "https://emojipedia.org/flag-libya/",
    emoji: "🇱🇾",
    emojiName: "🇱🇾 Flag: Libya",
    description:
      "The flag for Libya, which may show as the letters LY on some platforms.",
  },
  {
    "web-scraper-order": "1666027032-1592",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇻 Flag: Latvia",
    "flags-href": "https://emojipedia.org/flag-latvia/",
    emoji: "🇱🇻",
    emojiName: "🇱🇻 Flag: Latvia",
    description:
      "The flag for Latvia, which may show as the letters LV on some platforms.",
  },
  {
    "web-scraper-order": "1666027035-1595",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇺 Flag: Luxembourg",
    "flags-href": "https://emojipedia.org/flag-luxembourg/",
    emoji: "🇱🇺",
    emojiName: "🇱🇺 Flag: Luxembourg",
    description:
      "The flag for Luxembourg, which may show as the letters LU on some platforms",
  },
  {
    "web-scraper-order": "1666027038-1598",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇹 Flag: Lithuania",
    "flags-href": "https://emojipedia.org/flag-lithuania/",
    emoji: "🇱🇹",
    emojiName: "🇱🇹 Flag: Lithuania",
    description:
      "The flag for Lithuania, which may show as the letters LT on some platforms.",
  },
  {
    "web-scraper-order": "1666027041-1601",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇸 Flag: Lesotho",
    "flags-href": "https://emojipedia.org/flag-lesotho/",
    emoji: "🇱🇸",
    emojiName: "🇱🇸 Flag: Lesotho",
    description:
      "The flag for Lesotho, which may show as the letters LS on some platforms.",
  },
  {
    "web-scraper-order": "1666027043-1604",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇷 Flag: Liberia",
    "flags-href": "https://emojipedia.org/flag-liberia/",
    emoji: "🇱🇷",
    emojiName: "🇱🇷 Flag: Liberia",
    description:
      "The flag for Liberia, which may show as the letters LR on some platforms.",
  },
  {
    "web-scraper-order": "1666027046-1607",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇰 Flag: Sri Lanka",
    "flags-href": "https://emojipedia.org/flag-sri-lanka/",
    emoji: "🇱🇰",
    emojiName: "🇱🇰 Flag: Sri Lanka",
    description:
      "The flag for Sri Lanka, which may show as the letters LK on some platforms.",
  },
  {
    "web-scraper-order": "1666027049-1611",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇮 Flag: Liechtenstein",
    "flags-href": "https://emojipedia.org/flag-liechtenstein/",
    emoji: "🇱🇮",
    emojiName: "🇱🇮 Flag: Liechtenstein",
    description:
      "The flag for Liechtenstein, which may show as the letters LI on some platforms.",
  },
  {
    "web-scraper-order": "1666027052-1614",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇨 Flag: St. Lucia",
    "flags-href": "https://emojipedia.org/flag-st-lucia/",
    emoji: "🇱🇨",
    emojiName: "🇱🇨 Flag: St. Lucia",
    description:
      "The Flag: St. Lucia emoji is a flag sequence combining 🇱 Regional Indicator Symbol Letter L and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027055-1617",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇧 Flag: Lebanon",
    "flags-href": "https://emojipedia.org/flag-lebanon/",
    emoji: "🇱🇧",
    emojiName: "🇱🇧 Flag: Lebanon",
    description:
      "The flag for Lebanon, which may show as the letters LB on some platforms.",
  },
  {
    "web-scraper-order": "1666027057-1620",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇦 Flag: Laos",
    "flags-href": "https://emojipedia.org/flag-laos/",
    emoji: "🇱🇦",
    emojiName: "🇱🇦 Flag: Laos",
    description:
      "The flag for Laos, which may show as the letters LA on some platforms.",
  },
  {
    "web-scraper-order": "1666027060-1623",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇿 Flag: Kazakhstan",
    "flags-href": "https://emojipedia.org/flag-kazakhstan/",
    emoji: "🇰🇿",
    emojiName: "🇰🇿 Flag: Kazakhstan",
    description:
      "The flag for Kazakhstan, which may show as the letters KZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027063-1626",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇾 Flag: Cayman Islands",
    "flags-href": "https://emojipedia.org/flag-cayman-islands/",
    emoji: "🇰🇾",
    emojiName: "🇰🇾 Flag: Cayman Islands",
    description:
      "The flag for Cayman Islands, which may show as the letters KY on some platforms.",
  },
  {
    "web-scraper-order": "1666027065-1629",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇼 Flag: Kuwait",
    "flags-href": "https://emojipedia.org/flag-kuwait/",
    emoji: "🇰🇼",
    emojiName: "🇰🇼 Flag: Kuwait",
    description:
      "The flag for Kuwait, which may show as the letters KW on some platforms.",
  },
  {
    "web-scraper-order": "1666027067-1632",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇷 Flag: South Korea",
    "flags-href": "https://emojipedia.org/flag-south-korea/",
    emoji: "🇰🇷",
    emojiName: "🇰🇷 Flag: South Korea",
    description:
      "The flag for South Korea, which may show as the letters KR on some platforms.",
  },
  {
    "web-scraper-order": "1666027070-1635",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇵 Flag: North Korea",
    "flags-href": "https://emojipedia.org/flag-north-korea/",
    emoji: "🇰🇵",
    emojiName: "🇰🇵 Flag: North Korea",
    description:
      "The flag for North Korea, which may show as the letters KP on some platforms.",
  },
  {
    "web-scraper-order": "1666027072-1638",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇳 Flag: St. Kitts & Nevis",
    "flags-href": "https://emojipedia.org/flag-st-kitts-nevis/",
    emoji: "🇰🇳",
    emojiName: "🇰🇳 Flag: St. Kitts & Nevis",
    description:
      "The Flag: St. Kitts & Nevis emoji is a flag sequence combining 🇰 Regional Indicator Symbol Letter K and 🇳 Regional Indicator Symbol Letter N.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027075-1641",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇲 Flag: Comoros",
    "flags-href": "https://emojipedia.org/flag-comoros/",
    emoji: "🇰🇲",
    emojiName: "🇰🇲 Flag: Comoros",
    description:
      "The flag for Comoros, which may show as the letters KM on some platforms.",
  },
  {
    "web-scraper-order": "1666027078-1645",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇮 Flag: Kiribati",
    "flags-href": "https://emojipedia.org/flag-kiribati/",
    emoji: "🇰🇮",
    emojiName: "🇰🇮 Flag: Kiribati",
    description:
      "The flag for Kiribati, which may show as the letters KI on some platforms.",
  },
  {
    "web-scraper-order": "1666027080-1648",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇭 Flag: Cambodia",
    "flags-href": "https://emojipedia.org/flag-cambodia/",
    emoji: "🇰🇭",
    emojiName: "🇰🇭 Flag: Cambodia",
    description:
      "The flag for Cambodia, which may show as the letters KH on some platforms.",
  },
  {
    "web-scraper-order": "1666027083-1651",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇬 Flag: Kyrgyzstan",
    "flags-href": "https://emojipedia.org/flag-kyrgyzstan/",
    emoji: "🇰🇬",
    emojiName: "🇰🇬 Flag: Kyrgyzstan",
    description:
      "The flag for Kyrgyzstan, which may show as the letters KG on some platforms.",
  },
  {
    "web-scraper-order": "1666027085-1653",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇪 Flag: Kenya",
    "flags-href": "https://emojipedia.org/flag-kenya/",
    emoji: "🇰🇪",
    emojiName: "🇰🇪 Flag: Kenya",
    description:
      "The flag for Kenya, which may show as the letters KE on some platforms.",
  },
  {
    "web-scraper-order": "1666027087-1656",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇵 Flag: Japan",
    "flags-href": "https://emojipedia.org/flag-japan/",
    emoji: "🇯🇵",
    emojiName: "🇯🇵 Flag: Japan",
    description:
      "The flag for Japan, which may show as the letters JP on some platforms.",
  },
  {
    "web-scraper-order": "1666027090-1659",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇴 Flag: Jordan",
    "flags-href": "https://emojipedia.org/flag-jordan/",
    emoji: "🇯🇴",
    emojiName: "🇯🇴 Flag: Jordan",
    description:
      "The flag for Jordan, which may show as the letters JO on some platforms.",
  },
  {
    "web-scraper-order": "1666027094-1663",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇲 Flag: Jamaica",
    "flags-href": "https://emojipedia.org/flag-jamaica/",
    emoji: "🇯🇲",
    emojiName: "🇯🇲 Flag: Jamaica",
    description:
      "The flag for Jamaica, which may show as the letters JM on some platforms.",
  },
  {
    "web-scraper-order": "1666027096-1666",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇪 Flag: Jersey",
    "flags-href": "https://emojipedia.org/flag-jersey/",
    emoji: "🇯🇪",
    emojiName: "🇯🇪 Flag: Jersey",
    description:
      "The flag for Jersey, which may show as the letters JE on some platforms.",
  },
  {
    "web-scraper-order": "1666027098-1667",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇹 Flag: Italy",
    "flags-href": "https://emojipedia.org/flag-italy/",
    emoji: "🇮🇹",
    emojiName: "🇮🇹 Flag: Italy",
    description:
      "The flag for Italy, which may show as the letters IT on some platforms.",
  },
  {
    "web-scraper-order": "1666027101-1670",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇸 Flag: Iceland",
    "flags-href": "https://emojipedia.org/flag-iceland/",
    emoji: "🇮🇸",
    emojiName: "🇮🇸 Flag: Iceland",
    description:
      "The flag for Iceland, which may show as the letters IS on some platforms.",
  },
  {
    "web-scraper-order": "1666027103-1673",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇷 Flag: Iran",
    "flags-href": "https://emojipedia.org/flag-iran/",
    emoji: "🇮🇷",
    emojiName: "🇮🇷 Flag: Iran",
    description:
      "The flag for Iran, which may show as the letters IR on some platforms.",
  },
  {
    "web-scraper-order": "1666027105-1676",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇶 Flag: Iraq",
    "flags-href": "https://emojipedia.org/flag-iraq/",
    emoji: "🇮🇶",
    emojiName: "🇮🇶 Flag: Iraq",
    description:
      "The flag for Iraq, which may show as the letters IQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027108-1679",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇴 Flag: British Indian Ocean Territory",
    "flags-href": "https://emojipedia.org/flag-british-indian-ocean-territory/",
    emoji: "🇮🇴",
    emojiName: "🇮🇴 Flag: British Indian Ocean Territory",
    description:
      "The flag for British Indian Ocean Territory, which may show as the letters IO on some platforms. The same flag is used for Diego Garcia.",
  },
  {
    "web-scraper-order": "1666027110-1682",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇳 Flag: India",
    "flags-href": "https://emojipedia.org/flag-india/",
    emoji: "🇮🇳",
    emojiName: "🇮🇳 Flag: India",
    description:
      "The flag for India, which may show as the letters IN on some platforms.",
  },
  {
    "web-scraper-order": "1666027113-1684",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇲 Flag: Isle of Man",
    "flags-href": "https://emojipedia.org/flag-isle-of-man/",
    emoji: "🇮🇲",
    emojiName: "🇮🇲 Flag: Isle of Man",
    description:
      "The flag for Isle of Man, which may show as the letters IM on some platforms.",
  },
  {
    "web-scraper-order": "1666027115-1687",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇱 Flag: Israel",
    "flags-href": "https://emojipedia.org/flag-israel/",
    emoji: "🇮🇱",
    emojiName: "🇮🇱 Flag: Israel",
    description:
      "The flag for Israel, which may show as the letters IL on some platforms.",
  },
  {
    "web-scraper-order": "1666027118-1689",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇪 Flag: Ireland",
    "flags-href": "https://emojipedia.org/flag-ireland/",
    emoji: "🇮🇪",
    emojiName: "🇮🇪 Flag: Ireland",
    description:
      "The flag for Ireland, which may show as the letters IE on some platforms.",
  },
  {
    "web-scraper-order": "1666027120-1692",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇩 Flag: Indonesia",
    "flags-href": "https://emojipedia.org/flag-indonesia/",
    emoji: "🇮🇩",
    emojiName: "🇮🇩 Flag: Indonesia",
    description:
      "The flag for Indonesia, which may show as the letters ID on some platforms.",
  },
  {
    "web-scraper-order": "1666027123-1695",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇨 Flag: Canary Islands",
    "flags-href": "https://emojipedia.org/flag-canary-islands/",
    emoji: "🇮🇨",
    emojiName: "🇮🇨 Flag: Canary Islands",
    description:
      "The flag for Canary Islands, which may show as the letters IC on some platforms.",
  },
  {
    "web-scraper-order": "1666027125-1697",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇺 Flag: Hungary",
    "flags-href": "https://emojipedia.org/flag-hungary/",
    emoji: "🇭🇺",
    emojiName: "🇭🇺 Flag: Hungary",
    description:
      "The flag for Hungary, which may show as the letters HU on some platforms.",
  },
  {
    "web-scraper-order": "1666027128-1700",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇹 Flag: Haiti",
    "flags-href": "https://emojipedia.org/flag-haiti/",
    emoji: "🇭🇹",
    emojiName: "🇭🇹 Flag: Haiti",
    description:
      "The flag for Haiti, which may show as the letters HT on some platforms.",
  },
  {
    "web-scraper-order": "1666027130-1702",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇷 Flag: Croatia",
    "flags-href": "https://emojipedia.org/flag-croatia/",
    emoji: "🇭🇷",
    emojiName: "🇭🇷 Flag: Croatia",
    description:
      "The flag for Croatia, which may show as the letters HR on some platforms.",
  },
  {
    "web-scraper-order": "1666027133-1705",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇳 Flag: Honduras",
    "flags-href": "https://emojipedia.org/flag-honduras/",
    emoji: "🇭🇳",
    emojiName: "🇭🇳 Flag: Honduras",
    description:
      "The flag for Honduras, which may show as the letters HN on some platforms.",
  },
  {
    "web-scraper-order": "1666027136-1708",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇲 Flag: Heard & McDonald Islands",
    "flags-href": "https://emojipedia.org/flag-heard-mcdonald-islands/",
    emoji: "🇭🇲",
    emojiName: "🇭🇲 Flag: Heard & McDonald Islands",
    description:
      "The flag for  Heard & McDonald Islands, which may show as the letters HM on some platforms. This is the same flag as Australia.",
  },
  {
    "web-scraper-order": "1666027138-1711",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇰 Flag: Hong Kong SAR China",
    "flags-href": "https://emojipedia.org/flag-hong-kong-sar-china/",
    emoji: "🇭🇰",
    emojiName: "🇭🇰 Flag: Hong Kong SAR China",
    description:
      "The flag for Hong Kong, which may show as the letters HK on some platforms.",
  },
  {
    "web-scraper-order": "1666027140-1713",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇾 Flag: Guyana",
    "flags-href": "https://emojipedia.org/flag-guyana/",
    emoji: "🇬🇾",
    emojiName: "🇬🇾 Flag: Guyana",
    description:
      "The flag for Guyana, which may show as the letters GY on some platforms.",
  },
  {
    "web-scraper-order": "1666027143-1716",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇼 Flag: Guinea-Bissau",
    "flags-href": "https://emojipedia.org/flag-guinea-bissau/",
    emoji: "🇬🇼",
    emojiName: "🇬🇼 Flag: Guinea-Bissau",
    description:
      "The flag for Guinea-Bissau, which may show as the letters GW on some platforms.",
  },
  {
    "web-scraper-order": "1666027146-1718",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇺 Flag: Guam",
    "flags-href": "https://emojipedia.org/flag-guam/",
    emoji: "🇬🇺",
    emojiName: "🇬🇺 Flag: Guam",
    description:
      "The flag for Guam, which may show as the letters GU on some platforms.",
  },
  {
    "web-scraper-order": "1666027148-1721",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇹 Flag: Guatemala",
    "flags-href": "https://emojipedia.org/flag-guatemala/",
    emoji: "🇬🇹",
    emojiName: "🇬🇹 Flag: Guatemala",
    description:
      "The flag for Guatemala, which may show as the letters GT on some platforms.",
  },
  {
    "web-scraper-order": "1666027151-1723",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇸 Flag: South Georgia & South Sandwich Islands",
    "flags-href":
      "https://emojipedia.org/flag-south-georgia-south-sandwich-islands/",
    emoji: "🇬🇸",
    emojiName: "🇬🇸 Flag: South Georgia & South Sandwich Islands",
    description:
      "The Flag: South Georgia & South Sandwich Islands emoji is a flag sequence combining 🇬 Regional Indicator Symbol Letter G and 🇸 Regional Indicator Symbol Letter S.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027154-1726",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇷 Flag: Greece",
    "flags-href": "https://emojipedia.org/flag-greece/",
    emoji: "🇬🇷",
    emojiName: "🇬🇷 Flag: Greece",
    description:
      "The flag for Greece, which may show as the letters GR on some platforms.",
  },
  {
    "web-scraper-order": "1666027156-1729",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇶 Flag: Equatorial Guinea",
    "flags-href": "https://emojipedia.org/flag-equatorial-guinea/",
    emoji: "🇬🇶",
    emojiName: "🇬🇶 Flag: Equatorial Guinea",
    description:
      "The flag for Equatorial Guinea, which may show as the letters GQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027159-1732",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇵 Flag: Guadeloupe",
    "flags-href": "https://emojipedia.org/flag-guadeloupe/",
    emoji: "🇬🇵",
    emojiName: "🇬🇵 Flag: Guadeloupe",
    description:
      "The flag for Guadeloupe, which may show as the letters GP on some platforms.",
  },
  {
    "web-scraper-order": "1666027162-1734",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇳 Flag: Guinea",
    "flags-href": "https://emojipedia.org/flag-guinea/",
    emoji: "🇬🇳",
    emojiName: "🇬🇳 Flag: Guinea",
    description:
      "The flag for Guinea, which may show as the letters GN on some platforms.",
  },
  {
    "web-scraper-order": "1666027165-1736",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇲 Flag: Gambia",
    "flags-href": "https://emojipedia.org/flag-gambia/",
    emoji: "🇬🇲",
    emojiName: "🇬🇲 Flag: Gambia",
    description:
      "The flag for Gambia, which may show as the letters GM on some platforms.",
  },
  {
    "web-scraper-order": "1666027167-1739",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇱 Flag: Greenland",
    "flags-href": "https://emojipedia.org/flag-greenland/",
    emoji: "🇬🇱",
    emojiName: "🇬🇱 Flag: Greenland",
    description:
      "The flag for Greenland, which may show as the letters GL on some platforms.",
  },
  {
    "web-scraper-order": "1666027170-1741",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇮 Flag: Gibraltar",
    "flags-href": "https://emojipedia.org/flag-gibraltar/",
    emoji: "🇬🇮",
    emojiName: "🇬🇮 Flag: Gibraltar",
    description:
      "The flag for Gibraltar, which may show as the letters GI on some platforms.",
  },
  {
    "web-scraper-order": "1666027173-1745",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇭 Flag: Ghana",
    "flags-href": "https://emojipedia.org/flag-ghana/",
    emoji: "🇬🇭",
    emojiName: "🇬🇭 Flag: Ghana",
    description:
      "The flag for Ghana, which may show as the letters GH on some platforms.",
  },
  {
    "web-scraper-order": "1666027177-1748",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇬 Flag: Guernsey",
    "flags-href": "https://emojipedia.org/flag-guernsey/",
    emoji: "🇬🇬",
    emojiName: "🇬🇬 Flag: Guernsey",
    description:
      "The flag for Guernsey, which may show as the letters GG on some platforms.",
  },
  {
    "web-scraper-order": "1666027183-1751",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇫 Flag: French Guiana",
    "flags-href": "https://emojipedia.org/flag-french-guiana/",
    emoji: "🇬🇫",
    emojiName: "🇬🇫 Flag: French Guiana",
    description:
      "The flag for French Guiana, which may show as the letters GF on some platforms.",
  },
  {
    "web-scraper-order": "1666027186-1752",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇪 Flag: Georgia",
    "flags-href": "https://emojipedia.org/flag-georgia/",
    emoji: "🇬🇪",
    emojiName: "🇬🇪 Flag: Georgia",
    description:
      "The flag for Georgia, which may show as the letters GE on some platforms.",
  },
  {
    "web-scraper-order": "1666027190-1756",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇩 Flag: Grenada",
    "flags-href": "https://emojipedia.org/flag-grenada/",
    emoji: "🇬🇩",
    emojiName: "🇬🇩 Flag: Grenada",
    description:
      "The flag for Grenada, which may show as the letters GD on some platforms.",
  },
  {
    "web-scraper-order": "1666027192-1758",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇧 Flag: United Kingdom",
    "flags-href": "https://emojipedia.org/flag-united-kingdom/",
    emoji: "🇬🇧",
    emojiName: "🇬🇧 Flag: United Kingdom",
    description:
      "The flag for the United Kingdom, which may show as the letters GB on some platforms. England, Scotland and Wales also have individual emoji flags.",
  },
  {
    "web-scraper-order": "1666027194-1760",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇦 Flag: Gabon",
    "flags-href": "https://emojipedia.org/flag-gabon/",
    emoji: "🇬🇦",
    emojiName: "🇬🇦 Flag: Gabon",
    description:
      "The flag for Gabon, which may show as the letters GA on some platforms.",
  },
  {
    "web-scraper-order": "1666027203-1765",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇷 Flag: France",
    "flags-href": "https://emojipedia.org/flag-france/",
    emoji: "🇫🇷",
    emojiName: "🇫🇷 Flag: France",
    description:
      "The flag for France, which may show as the letters FR on some platforms.",
  },
  {
    "web-scraper-order": "1666027208-1768",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇴 Flag: Faroe Islands",
    "flags-href": "https://emojipedia.org/flag-faroe-islands/",
    emoji: "🇫🇴",
    emojiName: "🇫🇴 Flag: Faroe Islands",
    description:
      "The flag for Faroe Islands, which may show as the letters FO on some platforms.",
  },
  {
    "web-scraper-order": "1666027210-1770",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇲 Flag: Micronesia",
    "flags-href": "https://emojipedia.org/flag-micronesia/",
    emoji: "🇫🇲",
    emojiName: "🇫🇲 Flag: Micronesia",
    description:
      "The flag for Micronesia, which may show as the letters FM on some platforms.",
  },
  {
    "web-scraper-order": "1666027213-1772",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇰 Flag: Falkland Islands",
    "flags-href": "https://emojipedia.org/flag-falkland-islands/",
    emoji: "🇫🇰",
    emojiName: "🇫🇰 Flag: Falkland Islands",
    description:
      "The flag for Falkland Islands (Malvinas), which may show as the letters FK on some platforms.",
  },
  {
    "web-scraper-order": "1666027216-1775",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇯 Flag: Fiji",
    "flags-href": "https://emojipedia.org/flag-fiji/",
    emoji: "🇫🇯",
    emojiName: "🇫🇯 Flag: Fiji",
    description:
      "The flag for Fiji, which may show as the letters FJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027218-1778",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇮 Flag: Finland",
    "flags-href": "https://emojipedia.org/flag-finland/",
    emoji: "🇫🇮",
    emojiName: "🇫🇮 Flag: Finland",
    description:
      "The flag for Finland, which may show as the letters FI on some platforms.",
  },
  {
    "web-scraper-order": "1666027221-1779",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇺 Flag: European Union",
    "flags-href": "https://emojipedia.org/flag-european-union/",
    emoji: "🇪🇺",
    emojiName: "🇪🇺 Flag: European Union",
    description:
      "The flag for European Union, which may show as the letters EU on some platforms.",
  },
  {
    "web-scraper-order": "1666027223-1782",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇹 Flag: Ethiopia",
    "flags-href": "https://emojipedia.org/flag-ethiopia/",
    emoji: "🇪🇹",
    emojiName: "🇪🇹 Flag: Ethiopia",
    description:
      "The flag for Ethiopia, which may show as the letters ET on some platforms.",
  },
  {
    "web-scraper-order": "1666027226-1784",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇸 Flag: Spain",
    "flags-href": "https://emojipedia.org/flag-spain/",
    emoji: "🇪🇸",
    emojiName: "🇪🇸 Flag: Spain",
    description:
      "The flag for Spain, which may show as the letters ES on some platforms.",
  },
  {
    "web-scraper-order": "1666027228-1786",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇷 Flag: Eritrea",
    "flags-href": "https://emojipedia.org/flag-eritrea/",
    emoji: "🇪🇷",
    emojiName: "🇪🇷 Flag: Eritrea",
    description:
      "The flag for Eritrea, which may show as the letters ER on some platforms.",
  },
  {
    "web-scraper-order": "1666027231-1790",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇭 Flag: Western Sahara",
    "flags-href": "https://emojipedia.org/flag-western-sahara/",
    emoji: "🇪🇭",
    emojiName: "🇪🇭 Flag: Western Sahara",
    description:
      "The flag for Western Sahara, which may show as the letters EH on some platforms.",
  },
  {
    "web-scraper-order": "1666027234-1792",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇬 Flag: Egypt",
    "flags-href": "https://emojipedia.org/flag-egypt/",
    emoji: "🇪🇬",
    emojiName: "🇪🇬 Flag: Egypt",
    description:
      "The flag for Egypt, which may show as the letters EG on some platforms.",
  },
  {
    "web-scraper-order": "1666027237-1794",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇪 Flag: Estonia",
    "flags-href": "https://emojipedia.org/flag-estonia/",
    emoji: "🇪🇪",
    emojiName: "🇪🇪 Flag: Estonia",
    description:
      "The flag for Estonia, which may show as the letters EE on some platforms.",
  },
  {
    "web-scraper-order": "1666027240-1797",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇨 Flag: Ecuador",
    "flags-href": "https://emojipedia.org/flag-ecuador/",
    emoji: "🇪🇨",
    emojiName: "🇪🇨 Flag: Ecuador",
    description:
      "The flag for Ecuador, which may show as the letters EC on some platforms.",
  },
  {
    "web-scraper-order": "1666027242-1799",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇦 Flag: Ceuta & Melilla",
    "flags-href": "https://emojipedia.org/flag-ceuta-melilla/",
    emoji: "🇪🇦",
    emojiName: "🇪🇦 Flag: Ceuta & Melilla",
    description:
      "The flag for Ceuta, Melilla, which may show as the letters EA on some platforms. Uses the same flag as Spain.",
  },
  {
    "web-scraper-order": "1666027245-1802",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇿 Flag: Algeria",
    "flags-href": "https://emojipedia.org/flag-algeria/",
    emoji: "🇩🇿",
    emojiName: "🇩🇿 Flag: Algeria",
    description:
      "The flag for Algeria, which may show as the letters DZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027247-1804",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇴 Flag: Dominican Republic",
    "flags-href": "https://emojipedia.org/flag-dominican-republic/",
    emoji: "🇩🇴",
    emojiName: "🇩🇴 Flag: Dominican Republic",
    description:
      "The flag for Dominican Republic, which may show as the letters DO on some platforms.",
  },
  {
    "web-scraper-order": "1666027250-1807",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇲 Flag: Dominica",
    "flags-href": "https://emojipedia.org/flag-dominica/",
    emoji: "🇩🇲",
    emojiName: "🇩🇲 Flag: Dominica",
    description:
      "The flag for Dominica, which may show as the letters DM on some platforms.",
  },
  {
    "web-scraper-order": "1666027252-1808",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇰 Flag: Denmark",
    "flags-href": "https://emojipedia.org/flag-denmark/",
    emoji: "🇩🇰",
    emojiName: "🇩🇰 Flag: Denmark",
    description:
      "The flag for Denmark, which may show as the letters DK on some platforms.",
  },
  {
    "web-scraper-order": "1666027255-1812",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇯 Flag: Djibouti",
    "flags-href": "https://emojipedia.org/flag-djibouti/",
    emoji: "🇩🇯",
    emojiName: "🇩🇯 Flag: Djibouti",
    description:
      "The flag for Djibouti, which may show as the letters DJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027257-1814",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇬 Flag: Diego Garcia",
    "flags-href": "https://emojipedia.org/flag-diego-garcia/",
    emoji: "🇩🇬",
    emojiName: "🇩🇬 Flag: Diego Garcia",
    description:
      "The flag for Diego Garcia, which may show as the letters DG on some platforms. The same flag is used for British Indian Ocean Territory.",
  },
  {
    "web-scraper-order": "1666027260-1815",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇪 Flag: Germany",
    "flags-href": "https://emojipedia.org/flag-germany/",
    emoji: "🇩🇪",
    emojiName: "🇩🇪 Flag: Germany",
    description:
      "The flag for Germany, which may show as the letters DE on some platforms",
  },
  {
    "web-scraper-order": "1666027262-1817",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇿 Flag: Czechia",
    "flags-href": "https://emojipedia.org/flag-czechia/",
    emoji: "🇨🇿",
    emojiName: "🇨🇿 Flag: Czechia",
    description:
      "The flag for Czechia, which may show as the letters CZ on some platforms. Also known as Czech Republic.",
  },
  {
    "web-scraper-order": "1666027265-1820",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇾 Flag: Cyprus",
    "flags-href": "https://emojipedia.org/flag-cyprus/",
    emoji: "🇨🇾",
    emojiName: "🇨🇾 Flag: Cyprus",
    description:
      "The flag for Cyprus, which may show as the letters CY on some platforms.",
  },
  {
    "web-scraper-order": "1666027268-1822",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇽 Flag: Christmas Island",
    "flags-href": "https://emojipedia.org/flag-christmas-island/",
    emoji: "🇨🇽",
    emojiName: "🇨🇽 Flag: Christmas Island",
    description:
      "The flag for Christmas Island, which may show as the letters CX on some platforms.",
  },
  {
    "web-scraper-order": "1666027271-1825",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇼 Flag: Curaçao",
    "flags-href": "https://emojipedia.org/flag-curacao/",
    emoji: "🇨🇼",
    emojiName: "🇨🇼 Flag: Curaçao",
    description:
      "The flag for Curaçao, which may show as the letters CW on some platforms.",
  },
  {
    "web-scraper-order": "1666027274-1826",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇻 Flag: Cape Verde",
    "flags-href": "https://emojipedia.org/flag-cape-verde/",
    emoji: "🇨🇻",
    emojiName: "🇨🇻 Flag: Cape Verde",
    description:
      "The flag for Cape Verde, which may show as the letters CV on some platforms.",
  },
  {
    "web-scraper-order": "1666027276-1828",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇺 Flag: Cuba",
    "flags-href": "https://emojipedia.org/flag-cuba/",
    emoji: "🇨🇺",
    emojiName: "🇨🇺 Flag: Cuba",
    description:
      "The flag for Cuba, which may show as the letters CU on some platforms.",
  },
  {
    "web-scraper-order": "1666027279-1830",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇷 Flag: Costa Rica",
    "flags-href": "https://emojipedia.org/flag-costa-rica/",
    emoji: "🇨🇷",
    emojiName: "🇨🇷 Flag: Costa Rica",
    description:
      "The flag for Costa Rica, which may show as the letters CR on some platforms.",
  },
  {
    "web-scraper-order": "1666027282-1832",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇵 Flag: Clipperton Island",
    "flags-href": "https://emojipedia.org/flag-clipperton-island/",
    emoji: "🇨🇵",
    emojiName: "🇨🇵 Flag: Clipperton Island",
    description:
      "The flag for Clipperton Island, which may show as the letters CP on some platforms. Uses the same flag as France.",
  },
  {
    "web-scraper-order": "1666027284-1835",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇴 Flag: Colombia",
    "flags-href": "https://emojipedia.org/flag-colombia/",
    emoji: "🇨🇴",
    emojiName: "🇨🇴 Flag: Colombia",
    description:
      "The flag for Colombia, which may show as the letters CO on some platforms.",
  },
  {
    "web-scraper-order": "1666027287-1836",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇳 Flag: China",
    "flags-href": "https://emojipedia.org/flag-china/",
    emoji: "🇨🇳",
    emojiName: "🇨🇳 Flag: China",
    description:
      "The flag for China, which may show as the letters CN on some platforms.",
  },
  {
    "web-scraper-order": "1666027289-1838",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇲 Flag: Cameroon",
    "flags-href": "https://emojipedia.org/flag-cameroon/",
    emoji: "🇨🇲",
    emojiName: "🇨🇲 Flag: Cameroon",
    description:
      "The flag for Cameroon, which may show as the letters CM on some platforms.",
  },
  {
    "web-scraper-order": "1666027291-1840",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇱 Flag: Chile",
    "flags-href": "https://emojipedia.org/flag-chile/",
    emoji: "🇨🇱",
    emojiName: "🇨🇱 Flag: Chile",
    description:
      "The flag for Chile, which may show as the letters CL on some platforms.",
  },
  {
    "web-scraper-order": "1666027294-1842",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇰 Flag: Cook Islands",
    "flags-href": "https://emojipedia.org/flag-cook-islands/",
    emoji: "🇨🇰",
    emojiName: "🇨🇰 Flag: Cook Islands",
    description:
      "The flag for Cook Islands, which may show as the letters CK on some platforms.",
  },
  {
    "web-scraper-order": "1666027297-1844",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇮 Flag: Côte d’Ivoire",
    "flags-href": "https://emojipedia.org/flag-cote-divoire/",
    emoji: "🇨🇮",
    emojiName: "🇨🇮 Flag: Côte d’Ivoire",
    description:
      "The Flag: Côte d’Ivoire emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇮 Regional Indicator Symbol Letter I.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027299-1846",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇭 Flag: Switzerland",
    "flags-href": "https://emojipedia.org/flag-switzerland/",
    emoji: "🇨🇭",
    emojiName: "🇨🇭 Flag: Switzerland",
    description:
      "The flag for Switzerland, which may show as the letters CH on some platforms.",
  },
  {
    "web-scraper-order": "1666027303-1848",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇬 Flag: Congo - Brazzaville",
    "flags-href": "https://emojipedia.org/flag-congo-brazzaville/",
    emoji: "🇨🇬",
    emojiName: "🇨🇬 Flag: Congo - Brazzaville",
    description:
      "The Flag: Congo - Brazzaville emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇬 Regional Indicator Symbol Letter G.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027305-1850",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇫 Flag: Central African Republic",
    "flags-href": "https://emojipedia.org/flag-central-african-republic/",
    emoji: "🇨🇫",
    emojiName: "🇨🇫 Flag: Central African Republic",
    description:
      "The flag for Central African Republic, which may show as the letters CF on some platforms.",
  },
  {
    "web-scraper-order": "1666027308-1851",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇩 Flag: Congo - Kinshasa",
    "flags-href": "https://emojipedia.org/flag-congo-kinshasa/",
    emoji: "🇨🇩",
    emojiName: "🇨🇩 Flag: Congo - Kinshasa",
    description:
      "The Flag: Congo - Kinshasa emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇩 Regional Indicator Symbol Letter D.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027311-1854",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇨 Flag: Cocos (Keeling) Islands",
    "flags-href": "https://emojipedia.org/flag-cocos-keeling-islands/",
    emoji: "🇨🇨",
    emojiName: "🇨🇨 Flag: Cocos (Keeling) Islands",
    description:
      "The Flag: Cocos (Keeling) Islands emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027313-1855",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇦 Flag: Canada",
    "flags-href": "https://emojipedia.org/flag-canada/",
    emoji: "🇨🇦",
    emojiName: "🇨🇦 Flag: Canada",
    description:
      "The flag for Canada, which may show as the letters CA on some platforms.",
  },
  {
    "web-scraper-order": "1666027316-1858",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇿 Flag: Belize",
    "flags-href": "https://emojipedia.org/flag-belize/",
    emoji: "🇧🇿",
    emojiName: "🇧🇿 Flag: Belize",
    description:
      "The flag for Belize, which may show as the letters BZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027318-1859",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇾 Flag: Belarus",
    "flags-href": "https://emojipedia.org/flag-belarus/",
    emoji: "🇧🇾",
    emojiName: "🇧🇾 Flag: Belarus",
    description:
      "The flag for Belarus, which may show as the letters BY on some platforms.",
  },
  {
    "web-scraper-order": "1666027321-1862",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇼 Flag: Botswana",
    "flags-href": "https://emojipedia.org/flag-botswana/",
    emoji: "🇧🇼",
    emojiName: "🇧🇼 Flag: Botswana",
    description:
      "The flag for Botswana, which may show as the letters BW on some platforms.",
  },
  {
    "web-scraper-order": "1666027323-1863",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇻 Flag: Bouvet Island",
    "flags-href": "https://emojipedia.org/flag-bouvet-island/",
    emoji: "🇧🇻",
    emojiName: "🇧🇻 Flag: Bouvet Island",
    description:
      "The flag for Bouvet Island, which may show as the letters BV on some platforms. This is the same flag as Norway.",
  },
  {
    "web-scraper-order": "1666027326-1866",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇹 Flag: Bhutan",
    "flags-href": "https://emojipedia.org/flag-bhutan/",
    emoji: "🇧🇹",
    emojiName: "🇧🇹 Flag: Bhutan",
    description:
      "The flag for Bhutan, which may show as the letters BT on some platforms.",
  },
  {
    "web-scraper-order": "1666027328-1868",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇸 Flag: Bahamas",
    "flags-href": "https://emojipedia.org/flag-bahamas/",
    emoji: "🇧🇸",
    emojiName: "🇧🇸 Flag: Bahamas",
    description:
      "The flag for Bahamas, which may show as the letters BS on some platforms.",
  },
  {
    "web-scraper-order": "1666027331-1869",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇷 Flag: Brazil",
    "flags-href": "https://emojipedia.org/flag-brazil/",
    emoji: "🇧🇷",
    emojiName: "🇧🇷 Flag: Brazil",
    description:
      "The flag for Brazil, which may show as the letters BR on some platforms.",
  },
  {
    "web-scraper-order": "1666027334-1873",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇶 Flag: Caribbean Netherlands",
    "flags-href": "https://emojipedia.org/flag-caribbean-netherlands/",
    emoji: "🇧🇶",
    emojiName: "🇧🇶 Flag: Caribbean Netherlands",
    description:
      "The Caribbean Netherlands, a group of islands in the Caribbean Sea. The design for this emoji is shown as the flag for Bonaire on most platforms.",
  },
  {
    "web-scraper-order": "1666027336-1874",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇴 Flag: Bolivia",
    "flags-href": "https://emojipedia.org/flag-bolivia/",
    emoji: "🇧🇴",
    emojiName: "🇧🇴 Flag: Bolivia",
    description:
      "The flag for Bolivia, which may show as the letters BO on some platforms.",
  },
  {
    "web-scraper-order": "1666027339-1877",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇳 Flag: Brunei",
    "flags-href": "https://emojipedia.org/flag-brunei/",
    emoji: "🇧🇳",
    emojiName: "🇧🇳 Flag: Brunei",
    description:
      "The flag for Brunei Darussalam, which may show as the letters BN on some platforms.",
  },
  {
    "web-scraper-order": "1666027342-1880",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇲 Flag: Bermuda",
    "flags-href": "https://emojipedia.org/flag-bermuda/",
    emoji: "🇧🇲",
    emojiName: "🇧🇲 Flag: Bermuda",
    description:
      "The flag for Bermuda, which may show as the letters BM on some platforms.",
  },
  {
    "web-scraper-order": "1666027346-1881",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇱 Flag: St. Barthélemy",
    "flags-href": "https://emojipedia.org/flag-st-barthelemy/",
    emoji: "🇧🇱",
    emojiName: "🇧🇱 Flag: St. Barthélemy",
    description:
      "The Flag: St. Barthélemy emoji is a flag sequence combining 🇧 Regional Indicator Symbol Letter B and 🇱 Regional Indicator Symbol Letter L.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027349-1884",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇯 Flag: Benin",
    "flags-href": "https://emojipedia.org/flag-benin/",
    emoji: "🇧🇯",
    emojiName: "🇧🇯 Flag: Benin",
    description:
      "The flag for Benin, which may show as the letters BJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027351-1886",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇮 Flag: Burundi",
    "flags-href": "https://emojipedia.org/flag-burundi/",
    emoji: "🇧🇮",
    emojiName: "🇧🇮 Flag: Burundi",
    description:
      "The flag for Burundi, which may show as the letters BI on some platforms.",
  },
  {
    "web-scraper-order": "1666027353-1888",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇭 Flag: Bahrain",
    "flags-href": "https://emojipedia.org/flag-bahrain/",
    emoji: "🇧🇭",
    emojiName: "🇧🇭 Flag: Bahrain",
    description:
      "The flag for Bahrain, which may show as the letters BH on some platforms.",
  },
  {
    "web-scraper-order": "1666027356-1891",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇬 Flag: Bulgaria",
    "flags-href": "https://emojipedia.org/flag-bulgaria/",
    emoji: "🇧🇬",
    emojiName: "🇧🇬 Flag: Bulgaria",
    description:
      "The flag for Bulgaria, which may show as the letters BG on some platforms.",
  },
  {
    "web-scraper-order": "1666027359-1893",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇫 Flag: Burkina Faso",
    "flags-href": "https://emojipedia.org/flag-burkina-faso/",
    emoji: "🇧🇫",
    emojiName: "🇧🇫 Flag: Burkina Faso",
    description:
      "The flag for Burkina Faso, which may show as the letters BF on some platforms.",
  },
  {
    "web-scraper-order": "1666027362-1896",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇪 Flag: Belgium",
    "flags-href": "https://emojipedia.org/flag-belgium/",
    emoji: "🇧🇪",
    emojiName: "🇧🇪 Flag: Belgium",
    description:
      "The flag for Belgium, which may show as the letters BE on some platforms.",
  },
  {
    "web-scraper-order": "1666027364-1898",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇩 Flag: Bangladesh",
    "flags-href": "https://emojipedia.org/flag-bangladesh/",
    emoji: "🇧🇩",
    emojiName: "🇧🇩 Flag: Bangladesh",
    description:
      "The flag for Bangladesh, which may show as the letters BD on some platforms.",
  },
  {
    "web-scraper-order": "1666027367-1900",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇧 Flag: Barbados",
    "flags-href": "https://emojipedia.org/flag-barbados/",
    emoji: "🇧🇧",
    emojiName: "🇧🇧 Flag: Barbados",
    description:
      "The flag for Barbados, which may show as the letters BB on some platforms.",
  },
  {
    "web-scraper-order": "1666027370-1902",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇦 Flag: Bosnia & Herzegovina",
    "flags-href": "https://emojipedia.org/flag-bosnia-herzegovina/",
    emoji: "🇧🇦",
    emojiName: "🇧🇦 Flag: Bosnia & Herzegovina",
    description:
      "The Flag: Bosnia & Herzegovina emoji is a flag sequence combining 🇧 Regional Indicator Symbol Letter B and 🇦 Regional Indicator Symbol Letter A.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027373-1905",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇿 Flag: Azerbaijan",
    "flags-href": "https://emojipedia.org/flag-azerbaijan/",
    emoji: "🇦🇿",
    emojiName: "🇦🇿 Flag: Azerbaijan",
    description:
      "The flag for Azerbaijan, which may show as the letters AZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027376-1907",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇽 Flag: Åland Islands",
    "flags-href": "https://emojipedia.org/flag-aland-islands/",
    emoji: "🇦🇽",
    emojiName: "🇦🇽 Flag: Åland Islands",
    description:
      "The flag for Åland Islands, which may show as the letters AX on some platforms.",
  },
  {
    "web-scraper-order": "1666027379-1910",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇼 Flag: Aruba",
    "flags-href": "https://emojipedia.org/flag-aruba/",
    emoji: "🇦🇼",
    emojiName: "🇦🇼 Flag: Aruba",
    description:
      "The flag for Aruba, which may show as the letters AW on some platforms.",
  },
  {
    "web-scraper-order": "1666027381-1913",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇺 Flag: Australia",
    "flags-href": "https://emojipedia.org/flag-australia/",
    emoji: "🇦🇺",
    emojiName: "🇦🇺 Flag: Australia",
    description:
      "The flag for Australia, which may show as the letters AU on some platforms.",
  },
  {
    "web-scraper-order": "1666027384-1916",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇹 Flag: Austria",
    "flags-href": "https://emojipedia.org/flag-austria/",
    emoji: "🇦🇹",
    emojiName: "🇦🇹 Flag: Austria",
    description:
      "The flag for Austria, which may show as the letters AT on some platforms.",
  },
  {
    "web-scraper-order": "1666027386-1919",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇸 Flag: American Samoa",
    "flags-href": "https://emojipedia.org/flag-american-samoa/",
    emoji: "🇦🇸",
    emojiName: "🇦🇸 Flag: American Samoa",
    description:
      "The flag for American Samoa, which may show as the letters AS on some platforms.",
  },
  {
    "web-scraper-order": "1666027390-1922",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇷 Flag: Argentina",
    "flags-href": "https://emojipedia.org/flag-argentina/",
    emoji: "🇦🇷",
    emojiName: "🇦🇷 Flag: Argentina",
    description:
      "The flag for Argentina, which may show as the letters AR on some platforms.",
  },
  {
    "web-scraper-order": "1666027393-1924",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇶 Flag: Antarctica",
    "flags-href": "https://emojipedia.org/flag-antarctica/",
    emoji: "🇦🇶",
    emojiName: "🇦🇶 Flag: Antarctica",
    description:
      "The flag for Antarctica, which may show as the letters AQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027395-1927",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇴 Flag: Angola",
    "flags-href": "https://emojipedia.org/flag-angola/",
    emoji: "🇦🇴",
    emojiName: "🇦🇴 Flag: Angola",
    description:
      "The flag for Angola, which may show as the letters A and O on some platforms.",
  },
  {
    "web-scraper-order": "1666027398-1931",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇲 Flag: Armenia",
    "flags-href": "https://emojipedia.org/flag-armenia/",
    emoji: "🇦🇲",
    emojiName: "🇦🇲 Flag: Armenia",
    description:
      "The flag for Armenia, which may show as the letters AM on some platforms.",
  },
  {
    "web-scraper-order": "1666027401-1933",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇱 Flag: Albania",
    "flags-href": "https://emojipedia.org/flag-albania/",
    emoji: "🇦🇱",
    emojiName: "🇦🇱 Flag: Albania",
    description:
      "The flag for Albania, which may show as the letters AL on some platforms.",
  },
  {
    "web-scraper-order": "1666027404-1936",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇮 Flag: Anguilla",
    "flags-href": "https://emojipedia.org/flag-anguilla/",
    emoji: "🇦🇮",
    emojiName: "🇦🇮 Flag: Anguilla",
    description:
      "The flag for Anguilla, which may show as the letters AI on some platforms.",
  },
  {
    "web-scraper-order": "1666027407-1940",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇬 Flag: Antigua & Barbuda",
    "flags-href": "https://emojipedia.org/flag-antigua-barbuda/",
    emoji: "🇦🇬",
    emojiName: "🇦🇬 Flag: Antigua & Barbuda",
    description:
      "The Flag: Antigua & Barbuda emoji is a flag sequence combining 🇦 Regional Indicator Symbol Letter A and 🇬 Regional Indicator Symbol Letter G.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027409-1942",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇫 Flag: Afghanistan",
    "flags-href": "https://emojipedia.org/flag-afghanistan/",
    emoji: "🇦🇫",
    emojiName: "🇦🇫 Flag: Afghanistan",
    description:
      "The flag for Afghanistan, which may show as the letters AF on some platforms.",
  },
  {
    "web-scraper-order": "1666027411-1944",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇪 Flag: United Arab Emirates",
    "flags-href": "https://emojipedia.org/flag-united-arab-emirates/",
    emoji: "🇦🇪",
    emojiName: "🇦🇪 Flag: United Arab Emirates",
    description:
      "The flag for United Arab Emirates, which may show as the letters AE on some platforms.",
  },
  {
    "web-scraper-order": "1666027414-1947",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇩 Flag: Andorra",
    "flags-href": "https://emojipedia.org/flag-andorra/",
    emoji: "🇦🇩",
    emojiName: "🇦🇩 Flag: Andorra",
    description:
      "The flag for Andorra, which may show as the letters AD on some platforms.",
  },
  {
    "web-scraper-order": "1666027416-1949",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇨 Flag: Ascension Island",
    "flags-href": "https://emojipedia.org/flag-ascension-island/",
    emoji: "🇦🇨",
    emojiName: "🇦🇨 Flag: Ascension Island",
    description:
      "The flag for Ascension Island, which may show as the letters AC on some platforms. Apple devices show the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666027420-1952",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴‍☠️ Pirate Flag",
    "flags-href": "https://emojipedia.org/pirate-flag/",
    emoji: "🏴‍☠️",
    emojiName: "🏴‍☠️ Pirate Flag",
    description:
      "A skull and crossbones displayed on a black flag, used on pirate ships, also known as a Jolly Roger.",
  },
  {
    "web-scraper-order": "1666027422-1954",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️‍⚧️ Transgender Flag",
    "flags-href": "https://emojipedia.org/transgender-flag/",
    emoji: "🏳️‍⚧️",
    emojiName: "🏳️‍⚧️ Transgender Flag",
    description:
      "A flag with horizontal pale blue and pale pink stripes with a single white stripe in the middle, used as a Transgender or Transgender Pride flag and commonly seen at Pride events.",
  },
  {
    "web-scraper-order": "1666027425-1956",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️‍🌈 Rainbow Flag",
    "flags-href": "https://emojipedia.org/rainbow-flag/",
    emoji: "🏳️‍🌈",
    emojiName: "🏳️‍🌈 Rainbow Flag",
    description:
      "A flag with six colors of the rainbow, generally including red, orange, yellow, green, blue and purple. Commonly used by the LGBT movement as a gay pride flag, or simply pride flag and seen at Pride events.",
  },
  {
    "web-scraper-order": "1666027428-1959",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️ White Flag",
    "flags-href": "https://emojipedia.org/white-flag/",
    emoji: "🏳️",
    emojiName: "🏳️ White Flag",
    description:
      "A white flag, shown waving on a post. Traditionally used as a sign of surrender, the meaning of this flag as an emoji is less defined.",
  },
  {
    "web-scraper-order": "1666027431-1961",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴 Black Flag",
    "flags-href": "https://emojipedia.org/black-flag/",
    emoji: "🏴",
    emojiName: "🏴 Black Flag",
    description:
      "Black Flag was approved as part of Unicode 7.0 in 2014 under the name “Waving Black Flag” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027435-1965",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🎌 Crossed Flags",
    "flags-href": "https://emojipedia.org/crossed-flags/",
    emoji: "🎌",
    emojiName: "🎌 Crossed Flags",
    description:
      "Two Japanese Flags, crossed at the base. Except on some Samsung devices, which have previously displayed two South Korean flags.",
  },
  {
    "web-scraper-order": "1666027438-1968",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🚩 Triangular Flag",
    "flags-href": "https://emojipedia.org/triangular-flag/",
    emoji: "🚩",
    emojiName: "🚩 Triangular Flag",
    description:
      "A triangular red flag on a post. Most commonly associated with golf, as shown in the flag in hole emoji. Can also be used to represent the term red flag, signaling a problem or issue.",
  },
  {
    "web-scraper-order": "1666027442-1972",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏁 Chequered Flag",
    "flags-href": "https://emojipedia.org/chequered-flag/",
    emoji: "🏁",
    emojiName: "🏁 Chequered Flag",
    description:
      "A flag with black and white squares shown in a checkerboard pattern, used to signal the start or end of a motor car race.",
  },
];
export default flags;
